// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*import Vue from 'vue'*/


// import ElementUI from 'element-ui';
import App from './App';
import router from './router';
import store from './store';
import {getUserToken} from '@/utils/auth'; // 验权
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条样式
import * as filters from './filters'; // 全局filter
import {Message} from 'element-ui';
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});


router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getUserToken()) {
    if (to.path === '/login' || to.path === '/register') {
      next({path: '/'});
    } else {
      if (store.state.user.user_id <= 0) {
        store.dispatch('GetInfo')
          .then(res => {
            next();
            NProgress.done();
          })
          .catch(error => {

            store.dispatch('FedLogOut').then(() => {
              Message({
                message: error.code===-39?'您不是代理公司，没有权限,请向管理员申请':'验证失败,请重新登录',
                type: 'error',
              });
              next({path: '/login'});
              NProgress.done();
            });
          })
      } else {
        next()
      }

    }
  }
  else {
    if (to.path.startsWith('/user')) {
      next('/login');
      NProgress.done();
    }
    else {
      next()
    }
  }

});
router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

Vue.config.productionTip = true;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js